var Validation = function() {
    this.init();
};

Validation.prototype = {
    constructor: Validation,
    init: function() {
        $('.needs-validation').each(function() {
            this.addEventListener('submit', function(evt) {
                console.log(this);
                if (!this.checkValidity()) {
                    evt.preventDefault();
                    evt.stopPropagation();
                }
                this.classList.add('was-validated');
            }, false);
        });
    }
};

window.addEventListener('load', function() {
    var m = new Validation();
})